/**
 * Human-readable phrasing for the substrate's machine eDoc-poll outcome.
 *
 * Shared by ora (the check-edocs Remix route) and the Outlook add-in
 * (ReviewCheckpointPanel's "Check Now" side action) so the copy lives in ONE
 * place and can't drift. The generic HitlSideActions component shows whatever
 * message string it's handed; this maps the outcome to that string.
 *
 * Import in ora:     ~/common/workflows/edocCheckMessage
 * Import in add-in:  @product-app/common/workflows/edocCheckMessage
 */
export function edocCheckMessage(outcome: string): string {
  switch (outcome) {
    case "released":
      return "Documents found — the workflow is resuming.";
    case "no_edoc_yet":
      return "No documents have arrived yet — still waiting on the carrier; the daily check keeps looking.";
    case "ambiguous":
      return "Multiple possible documents were found — this needs a manual review.";
    case "error":
      return "The check could not be completed. Please try again shortly.";
    default:
      return `Checked (${outcome}).`;
  }
}
